import NumericHybridFacet from '@features/filter/components/Filters/NumericHybridFacet';

import type {
  Facet as FacetType,
  InputFacet as InputFacetType,
  NumericHybridFacet as NumericHybridFacetType,
  RangeFacet as RangeFacetType,
  ValueFacet as ValueFacetType
} from '../../../types';
import CombinedBooleanFacet from '../CombinedBooleanFacet';
import InputFacet from '../InputFacet';
import RangeFacet from '../RangeFacet';
import RatingFacet from '../RatingFacet';
import ValueFacet from '../ValueFacet';

const COMBINED_BOOLEAN_FILTER_TYPE = 'CombinedBooleanFacet';
const NUMERIC_HYBRID_FILTER_TYPE = 'NumericHybridFacet';
const RATING_FILTER_TYPE = 'RatingFacet';
const INPUT_FILTER_TYPE = 'InputFacet';
const RANGE_FILTER_TYPE = 'RangeFacet';

export default function mapFacetToFilterGroup(facet: FacetType) {
  const { facetName, __typename } = facet;

  if (__typename === COMBINED_BOOLEAN_FILTER_TYPE) {
    return <CombinedBooleanFacet facet={facet as ValueFacetType} key={facetName} />;
  }

  if (__typename === NUMERIC_HYBRID_FILTER_TYPE) {
    return <NumericHybridFacet facet={facet as NumericHybridFacetType} />;
  }

  if (__typename === RATING_FILTER_TYPE) {
    return <RatingFacet facet={facet as ValueFacetType} key={facetName} />;
  }

  if (__typename === INPUT_FILTER_TYPE) {
    return <InputFacet facet={facet as InputFacetType} key={facetName} />;
  }

  if (__typename === RANGE_FILTER_TYPE) {
    return <RangeFacet facet={facet as RangeFacetType} key={facetName} />;
  }

  return <ValueFacet facet={facet as ValueFacetType} key={facetName} />;
}
